module.exports = __webpack_public_path__ + "static/media/temp_21.caa98642.jpg";